import { tagInterface as tagInterfaceRegistry } from '@ardoq/tag-interface';
// eslint-disable-next-line no-restricted-imports
import { tagInterface } from './tagInterface';

export const initializeTagInterface = () => {
  tagInterfaceRegistry.registerImplementation(tagInterface);
};
